import { useState, useContext } from 'react';
import { PageLoadingContext } from '../../loader/contexts/PageLoadingContext';
import { LocalFilesService } from '../../shared/services/localFilesService';
import { getReport } from '../../shared/services/downloadReportService';
import { DATA_DOWNLOAD_TYPES } from '../../shared/constants/DataDownloadTypes';
import { REPORT_FORMAT_TYPES } from '@shared/constants/reportFormatTypes';

const DEFAULT_SELECTIONS = {
  [DATA_DOWNLOAD_TYPES.appraisal]: {
    orgIds: [],
    orgUnitIds: [],
    programYears: [],
    practiceAreas: [],
    practiceGroupLevels: []
  },
  [DATA_DOWNLOAD_TYPES.checkPoint]: {
    orgIds: [],
    orgUnitIds: []
  },
  [DATA_DOWNLOAD_TYPES.eventComment]: {
    orgIds: [],
    orgUnitIds: []
  }
};

const FILE_NAME_MAP = {
  [DATA_DOWNLOAD_TYPES.appraisal]: 'appraisalData.csv',
  [DATA_DOWNLOAD_TYPES.checkPoint]: 'checkPointData.csv',
  [DATA_DOWNLOAD_TYPES.eventComment]: 'eventComments.csv',
  [DATA_DOWNLOAD_TYPES.deDuplicatedMetrics]: 'deDuplicatedMetrics.csv'
};

const useDataDownload = dataType => {
  const { executeWithLoadingIndicator } = useContext(PageLoadingContext);

  const [fileDownloadError, setFileDownloadError] = useState(
    /** @type {string | undefined} */ (undefined)
  );
  const [selections, setSelections] = useState(DEFAULT_SELECTIONS[dataType]);

  const csvFileName = FILE_NAME_MAP[dataType];

  const handleSelections = propName => selectedOptions => {
    setSelections(prevState => ({ ...prevState, [propName]: selectedOptions }));
  };

  const handleDownloadClick = async () =>
    await executeWithLoadingIndicator(async () => {
      try {
        const response = await getReport(selections, dataType, REPORT_FORMAT_TYPES.CSV);
        LocalFilesService.saveBlobToFile(csvFileName, response.data);
      } catch (e) {
        setFileDownloadError('Failed to download report.');
      }
    });

  return {
    selections,
    handleSelections,
    handleDownloadClick,
    fileDownloadError
  };
};

export default useDataDownload;
